/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";
import SoftButton from "components/SoftComponents/SoftButton";
import { Link } from "react-router-dom";
import fileDownload from "js-file-download";
import { useAuth0 } from "@auth0/auth0-react";
import ParkingValidation from "assets/json/ParkingValidation.json";
import reportsAPI from "services/api/reports";
import { useState } from "react";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import theme from "assets/theme";
import Swal from "sweetalert2";

function ReportGenerationCard({ devices, deviceLayout }) {
    reportsAPI.loadToken(useAuth0());

    const [reportStartTime, setReportStartTime] = useState(moment.tz(ParkingValidation['timezone']).startOf('day').unix());

    var device_uuids = devices.filter((row) => row.hardware_type == "bk-camera" && row.active).map((row) => row.uuid);

    async function downloadPDF() {
        Swal.showLoading();

        const options = {
            responseType: 'blob',
            onDownloadProgress: function (progressEvent) {
                const percentComplete = Math.floor((progressEvent.loaded / progressEvent.total) * 100);
                if (percentComplete == 100) {
                    Swal.close();
                }
            }
        }

        var reportEndTime = moment(reportStartTime * 1000).tz(ParkingValidation['timezone']).add(1, 'day').startOf('day').unix();
        reportsAPI.getCameraObjectsReport(device_uuids, reportStartTime, reportEndTime, options).then(function (data) {
            var formatted_start_time = moment(reportStartTime * 1000).tz(ParkingValidation['timezone']).format('DDMM');

            fileDownload(data, `Nodes_${formatted_start_time}.pdf`);
        });
    };

    return (
        <SoftBox height="100%" display="flex" flexDirection="column" justifyContent="center" alignItems="center" variant="gradient" sx={({ palette: { white }, functions: { rgba } }) => ({ borderRadius: '20px', backgroundColor: rgba(white.main, 0.8) })}>
            <SoftBox height="60%" display="flex" flex={1} flexDirection="row" py={2} px={5}>
                <SoftBox display="flex" justifyContent="center" alignItems="center" mx={3}>
                    <SoftTypography variant="body2" textAlign="center">
                        Generate 24-hour infringment reports for all camera nodes with a selected date.
                    </SoftTypography>
                </SoftBox>
            </SoftBox>
            <SoftBox height="40%" minHeight="fit-content" display="flex" flexDirection={{ xxs: 'column', sm: 'row' }} alignItems="center" justifyContent="center" m={1}>
                <SoftBox display="flex" alignItems="center" px={1}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker format="DD/MM/YYYY" value={moment(reportStartTime * 1000)} minDate={moment("YYYY-MM-DD", "2026-03-01")} maxDate={moment()} onChange={(new_value) => { setReportStartTime(new_value.unix()) }} />
                    </LocalizationProvider>
                    <SoftBox px={1} display={theme.breakpoints.up("sm") ? 'none' : 'flex'}>
                        <SoftButton variant="gradient" color="info" onClick={() => { downloadPDF(); }}>Generate Report</SoftButton>
                    </SoftBox>
                </SoftBox>
                <SoftBox px={1} mt={{xxs: 1, sm: 0}} display={theme.breakpoints.up("sm") ? 'flex' : 'none'}>
                    <SoftButton variant="gradient" color="info" onClick={() => { downloadPDF(); }}>Generate Report</SoftButton>
                </SoftBox>
            </SoftBox>
        </SoftBox>
    );
}

// Typechecking props for the ReportGenerationCard
ReportGenerationCard.propTypes = {
    devices: PropTypes.array,
    deviceLayout: PropTypes.string
};

export default ReportGenerationCard;
